/**
 * Transfer status names
 *
 * @note Keep this in sync with the status constants in the backend (see Transfer.php)
 */
export const PENDING = 'pending'; // Default
export const SUCCEEDED = 'succeeded';
export const FAILED = 'failed';
